var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFisicalFaces(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 21.6L2.2504 17.9996C2.25063 16.0116 3.86234 14.4 5.8504 14.4H12.45M21.75 15.6H16.35M17.25 2.40002C18.7062 3.2163 19.65 4.5249 19.65 6.00002C19.65 7.47515 18.7062 8.78375 17.25 9.60002M14.25 6.00002C14.25 7.98825 12.6382 9.60002 10.65 9.60002C8.66177 9.60002 7.05 7.98825 7.05 6.00002C7.05 4.0118 8.66177 2.40002 10.65 2.40002C12.6382 2.40002 14.25 4.0118 14.25 6.00002Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFisicalFaces);
export default __webpack_public_path__ + "static/media/fisical-faces.817b269357452a9b8c3ae5290ba17245.svg";
export { ForwardRef as ReactComponent };